<template>
  <div class="login-page min-h-screen flex items-center justify-center bg-gray-100 p-4">
    <LoadingSpinner :loading="loading" message="Signing in..." />
    <Toast ref="toast" />
    <div class="max-w-screen-xl mx-auto flex w-full">
      <!-- Left Side - Login Form -->
      <div class="flex-1 flex justify-center">
        <LoginForm />
      </div>
      
      <!-- Right Side - Image and Text (Hidden on mobile) -->
      <div class="hidden md:flex flex-1 bg-primary-600 rounded-lg shadow-lg overflow-hidden">
        <div class="p-12 flex flex-col justify-center text-white">
          <h2 class="text-3xl font-bold mb-6">Welcome Back to GeoProperty Hub</h2>
          <p class="text-xl mb-8">
            Log in to access your property dashboard, manage listings, and track payments.
          </p>
          <div class="space-y-4">
            <div class="flex items-center">
              <i class="fas fa-map-marked-alt text-primary-300 text-xl mr-4"></i>
              <span>Interactive property visualization</span>
            </div>
            <div class="flex items-center">
              <i class="fas fa-chart-line text-primary-300 text-xl mr-4"></i>
              <span>Comprehensive analytics dashboard</span>
            </div>
            <div class="flex items-center">
              <i class="fas fa-money-check-alt text-primary-300 text-xl mr-4"></i>
              <span>Real-time payment tracking</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import LoadingSpinner from '../components/LoadingSpinner.vue';
import Toast from '../components/Toast.vue';
import LoginForm from '../components/LoginForm.vue';

const router = useRouter();
const authStore = useAuthStore();
const loading = ref(false);
const toast = inject('toast');

const handleLogin = async () => {
  loading.value = true;
  try {
    await authStore.login(email.value, password.value);
    toast.value?.addToast('Successfully logged in!', 'success');
    router.push('/dashboard');
  } catch (error) {
    toast.value?.addToast(error.message || 'Failed to login', 'error');
  } finally {
    loading.value = false;
  }
};
</script>
